import { Months, MonthsRU } from "shared/components/designer-details/utils";

export const getYearItems = (): any[] => {
    const years = [];

    for (let year = 2000; year <= new Date()?.getFullYear(); year++) {
        years.push(year)
    }

    //@ts-ignore
    return years?.reduce((acc, val) => ([...acc, { value: val, label: val }]) , [])?.reverse()
}


export const getMonthItems = (lang: string): any[] => 
  //@ts-ignore
    [...(lang === 'ru' ? MonthsRU : Months)]?.reduce((acc,val, ind) => ([...acc, { label: val, value: String(ind + 1)}]) , [])import { Months, MonthsRU } from "shared/components/designer-details/utils";

export const getYearItems = (): any[] => {
    const years = [];

    for (let year = 2000; year <= new Date()?.getFullYear(); year++) {
        years.push(year)
    }

    //@ts-ignore
    return years?.reduce((acc, val) => ([...acc, { value: val, label: val }]) , [])?.reverse()
}


export const getMonthItems = (lang: string): any[] => 
  //@ts-ignore
    [...(lang === 'ru' ? MonthsRU : Months)]?.reduce((acc,val, ind) => ([...acc, { label: val, value: String(ind + 1)}]) , [])